import { Breadcrumb, LogoMarquee } from '@/components'
import BottomBanner from './components/BottomBanner'
import ExperienceSection from './components/ExperienceSection'
import HeroBanner from './components/HeroBanner'
import ServiceContent from './components/ServiceContent'
import ServiceFeatures from './components/ServiceFeatures'

const Vip = () => (
  <div className="min-w-[1200px]">
    <HeroBanner />
    <Breadcrumb currentKey="vip.breadcrumb.current" />
    <ExperienceSection />
    <div className="w-full bg-[#FAFAFA] pb-[108px] pt-[76px]">
      <LogoMarquee />
    </div>
    <ServiceContent />
    <ServiceFeatures />
    <BottomBanner />
  </div>
)

export default Vip
